import React, { Suspense, useContext, lazy } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import NotFound from "../components/NotFound/NotFound";
import Unauthorized from "../components/Unauthorized/Unauthorized";
import Loader from "../components/AppLoader/Loader";
import DefaultLayouts from "../layouts/defaultLayouts";
import BlankLayouts from "../layouts/blankLayouts";
import AuthContext from "../hooks/authContext";
import { routes } from "../services/routes";
import PublicLayouts from "../layouts/publicLayouts";
import UpgradePage from "./Accounts/Upgrade/Upgrade";
import SubscriptionInvalidPage from "../components/Unauthorized/SubscriptionNotValid";
import LoginUser from "./auth/LoginUser";

// Lazy load heavy components for better performance
const HomeContainer = lazy(() => import("./home/home.container"));
/**
 * Manage App routes layout and authentication
 * @param {*} props
 * @returns
 */
const AppRoutes = ({ isLoading, ...props }) => {
  const auth = useContext(AuthContext);
  const substatus = auth?.substatus;
  const navigate = useNavigate();
  const rawRole = auth?.userProfile?.role;
  const employeeRole = auth?.userProfile?.employeerole;

  let userRoles = Array.isArray(rawRole) ? [...rawRole] : rawRole ? [rawRole] : [];
  userRoles = userRoles.map((r) => (r === "Employee" && employeeRole ? employeeRole : r));
  userRoles = [...new Set(userRoles?.filter(Boolean))];
  // let userRoles = [...(Array.isArray(rawRole) ? rawRole : rawRole ? [rawRole] : [])]?.map((r) => (r === "Employee" && employeeRole ? employeeRole : r))?.filter(Boolean);
  // let userRoles = [...(rawRole === "Employee" && employeeRole ? [employeeRole] : [])]?.map((r) => (Array.isArray(rawRole) ? rawRole : rawRole ? [rawRole] : []))?.filter(Boolean);
  // userRoles = [...new Set(userRoles?.filter(Boolean))];

  const role =
    auth?.userProfile?.role === "Employee"
      ? auth?.userProfile?.employeerole
      : auth?.userProfile?.role;
  const allowedRoutesWithoutSubscription = ["/account/profile"];

  const CheckSecureRoute = (route) => {
    // Block route decisions until global auth state is resolved
    if (auth?.isLoading) {
      return <Loader />;
    }

    const RouteComponent = route.component;
    // const role = auth?.userProfile?.role;
    const userPackageId = auth?.userProfile?.prdId;
    // const allowedPermissions = packageAccess(userPackageId);
    // const hasAccess = Array.isArray(route?.roles) && route?.roles?.some((r) => userRoles?.includes(r));
    const hasAccess = route?.roles?.some(r => userRoles.includes(r));

    if (userRoles.includes("superUser")) {
      if (auth.status === true && hasAccess) {
        return <RouteComponent {...props} />;
      } else {
        if (auth?.status !== true && auth?.loginBack === true) {
          return <LoginUser />;
        } else {
          return <Unauthorized />;
        }
      }
    }

    if (route.secure === true) {
      if (auth.status === true && hasAccess) {
        // if (allowedPermissions?.routes?.includes(route?.pkgAccess)) {
        if (substatus === true && !allowedRoutesWithoutSubscription.includes(route.path)) {
          if (userRoles.includes("companyUser")) {
            return <UpgradePage />;
          } else {
            return <SubscriptionInvalidPage />;
          }
        }
        // } else {
        //   return <Unauthorized />;
        // }
        return <RouteComponent {...props} />;
      } else {
        // If auth is strictly NOT true and we finished loading, then decide:
        if (auth?.status !== true && auth?.loginBack === true) {
          return <LoginUser />;
        } else {
          return <Unauthorized />;
        }
      }
    }
    return <RouteComponent {...props} />;
  };

  const routerItem = (route) => {
    if (route.layout === "blank") {
      return (
        <Route
          key={route.index}
          path={route.path}
          element={
            <BlankLayouts {...props}>{CheckSecureRoute(route)}</BlankLayouts>
          }
          render={(props) => (
            <BlankLayouts {...props}>{CheckSecureRoute(route)}</BlankLayouts>
          )}
          exact={route.exact}
        />
      );
    } else if (route.layout === "public") {
      return (
        <Route
          key={route.index}
          path={route.path}
          element={
            <PublicLayouts {...props}>{CheckSecureRoute(route)}</PublicLayouts>
          }
          render={(props) => (
            <PublicLayouts {...props}>{CheckSecureRoute(route)}</PublicLayouts>
          )}
          exact={route.exact}
        />
      );
    } else {
      return (
        <Route
          key={route.index}
          path={route.path}
          element={
            <DefaultLayouts {...props} isSecure={true} isLoading={isLoading}>
              {CheckSecureRoute(route)}
            </DefaultLayouts>
          }
          render={(props) => (
            <DefaultLayouts {...props} isSecure={true} isLoading={isLoading}>
              {CheckSecureRoute(route)}
            </DefaultLayouts>
          )}
          exact={route.exact}
        />
      );
    }
  };

  const renderRoutes = () => {
    return routes?.map((route) => {
      return routerItem(route);
    });
  };

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {renderRoutes()}
        <Route
          path="*"
          element={
            <DefaultLayouts {...props} isSecure={true}>
              <NotFound {...props} />
            </DefaultLayouts>
          }
        />
      </Routes>
    </Suspense>
  );
};

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const history = useNavigate();
    return <Component history={history} {...props} />;
  };
  return Wrapper;
};

export default withRouter(AppRoutes);
